<template>
	<div class="player-details">
		<div class="player-details__you">
			<div class="details">
				<div class="player-details__user-img-container">
					<img
						:src="$options.UserYou"
						alt="you" />
				</div>

				<h6>{{ $options.ACTIVE_PLAYER.you.label }}</h6>
			</div>

			<div class="player-details__progressbar">
				<div
					class="progressbar-success"
					:style="`width: ${progressScore.you}%`">
					<p v-if="scoresMap.you">{{ scoresMap.you }}</p>
				</div>
			</div>
		</div>

		<p class="player-details__msg">{{ currentPlayer }}</p>

		<div class="player-details__nexibot">
			<div class="details">
				<div class="player-details__user-img-container">
					<img
						:src="$options.UserNexibot"
						alt="you" />
				</div>

				<h6>{{ $options.ACTIVE_PLAYER.computer.label }}</h6>
			</div>

			<div class="player-details__progressbar">
				<div
					class="progressbar-success"
					:style="`width: ${progressScore.computer}%`">
					<p v-if="scoresMap.computer">{{ scoresMap.computer }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import UserYou from '@/assets/user-male.png';
	import UserNexibot from '@/assets/user-female.png';

	import { ACTIVE_PLAYER, SCORE_IDX_MAP } from '@/reference';

	export default {
		name: 'player-details',
		props: {
			activePlayer: { type: String, default: ACTIVE_PLAYER.you.id },
			playerScores: { type: String },
		},
		computed: {
			currentPlayer() {
				switch (this.activePlayer) {
					case ACTIVE_PLAYER.you.id:
						return 'Your turn!';

					case ACTIVE_PLAYER.computer.id:
						return 'Computer‘s turn!';

					default:
						return 'First to score 5 wins!';
				}
			},
			scoresMap() {
				return {
					computer: this.playerScores[SCORE_IDX_MAP[ACTIVE_PLAYER.computer.id]],
					you: this.playerScores[SCORE_IDX_MAP[ACTIVE_PLAYER.you.id]],
				};
			},
			progressScore() {
				const [you, computer] = this.playerScores;

				return {
					computer: (computer / 5) * 100,
					you: (you / 5) * 100,
				};
			},
		},
		ACTIVE_PLAYER,
		UserNexibot,
		UserYou,
	};
</script>

<style lang="scss">
	.player-details {
		@include make-grid-cols(minmax(80px, 1fr) minmax(80px, 100px) minmax(80px, 1fr), 16px);
		@extend %align-items-center;

		&__user-img-container {
			$containerSize: 80px;

			width: $containerSize;
			height: $containerSize;
			background-color: color('soft-cream');
			border: 6px solid color('coral-blush');
			border-radius: 50%;
			box-shadow: 0px 4px 4px rgba(color('black'), 0.25);
			position: relative;
			/* padding: 16px; */

			@include responsive(medium) {
				width: 50px;
				height: 50px;
			}

			img {
				@extend %absolute-center-xy;
				height: 45px;
				width: 45px;

				@include responsive(medium) {
					width: 25px;
					height: 25px;
				}
			}
		}

		&__msg {
			font-weight: var(--font-weight-bold);
			text-align: center;
		}

		&__you,
		&__nexibot {
			&,
			.details {
				@extend %align-items-center;
				gap: 16px;

				@include responsive(medium) {
					gap: 8px;
				}
			}

			.details {
				@include responsive(medium) {
					flex-direction: column !important;
					gap: 8px;
				}
			}
		}

		&__you {
			&,
			.details {
				@extend %flex-row;
			}
		}

		&__nexibot {
			&,
			.details {
				@include flex(row-reverse);
			}
		}

		&__progressbar {
			height: 12px;
			/* min-width: 100px; */
			width: 100%;
			max-width: 280px;
			/* width: 280px; */
			background-color: color('soft-cream');
			overflow: hidden;

			&,
			.progressbar-success {
				border-radius: 100px;
			}

			.progressbar-success {
				@extend %layout-flex-center-x, %justify-content-flex-end;
				height: 100%;
				background-color: color('teal-tide');
				transition: width 1s ease;

				p {
					font-size: 10px;
					font-weight: var(--font-weight-bold);
					color: color('white-1');
					margin: 0 6px;
				}
			}
		}
	}
</style>
